import React, { useState, useEffect } from "react";
import { tagName, tagColor } from "./TagsInput"; // Reuse functions from TagsInput

const SelectableTags = ({ relevantTags, alreadySelectedTags = [], onSelectionChange, language }) => {
  const [selectedTags, setSelectedTags] = useState([]);
  const [showAllTags, setShowAllTags] = useState(false);

  useEffect(() => {
    setSelectedTags(alreadySelectedTags);
  });

  const toggleTagSelection = (selectedTag) => {
    let updatedSelection;
    if (selectedTags.find((t) => t.tag.name === selectedTag.tag.name)) {
      updatedSelection = selectedTags.filter((t) => t.tag.name !== selectedTag.tag.name);
    } else {
      updatedSelection = [...selectedTags, selectedTag];
    }
    setSelectedTags(updatedSelection);
    onSelectionChange(updatedSelection);
  };

  const filteredTags = showAllTags
    ? relevantTags
    : relevantTags.filter((tagObject) => tagObject.tag.type === 3 || tagObject.tag.type === 4 || tagObject.tag.type === 2);

  const hasAdditionalTags = relevantTags.some(
    (tagObject) => tagObject.tag.type !== 3 && tagObject.tag.type !== 4
  );

  return (
    <div>
      <div className={`flex flex-wrap items-center`}>
        {filteredTags.map((tagObject, index) => {
          const { name } = tagObject.tag;
          const { count } = tagObject;
          const { type } = tagObject.tag;

          return (
            <div
              key={index}
              className={`mr-2 mb-1.5 cursor-pointer px-2 py-1 rounded whitespace-nowrap ${
                selectedTags.find((t) => t.tag.name === name)
                  ? tagColor(name, true, "bg-blue-600", type)
                  : tagColor(name, true, undefined, type)
              }`}
              onClick={() => toggleTagSelection(tagObject)}
            >
              {tagObject.tag.imgUrl !== "" ? (
                <div className="flex items-center text-center max-h-6">
                  #
                  <img className="w-5 max-w-none h-5 rounded-full" src={tagObject.tag.imgUrl} />
                  {tagName(name, language)}&nbsp;
                  <span className="text-xs text-gray-200">({count})</span>
                </div>
              ) : (
                <>
                  {tagName(name, language)}&nbsp;
                  <span className="text-xs text-gray-200">({count})</span>
                </>
              )}
            </div>
          );
        })}
        {!showAllTags && hasAdditionalTags && (
          <button
            className="ml-2 mb-1 cursor-pointer text-sm font-medium text-gray-500 hover:text-gray-700"
            onClick={() => setShowAllTags(true)}
            title="Show all tags"
          >
            {language === "ru" ? "Показать все" : "Show all"}
          </button>
        )}
        {showAllTags && (
          <button
            className="ml-2 mb-1 cursor-pointer text-sm font-medium text-gray-500 hover:text-gray-700"
            onClick={() => setShowAllTags(false)}
            title="Hide tags"
          >
            {language === "ru" ? "Скрыть" : "Hide"}
          </button>
        )}
      </div>
    </div>
  );
};

export default SelectableTags;